import React from 'react'
import { ResponsivePie } from '@nivo/pie'
// import data from './data.json'

function PieChart({completedData}) {

    let accumulator = 0

    for(let i = 0; i < completedData[0].length; i++){
       accumulator += completedData[0][i].value
    }

    let data = [
        {
          "id": "erlang",
          "label": "erlang",
          "value": accumulator,
          "color": "hsl(342, 70%, 50%)"
        },
        {
            "id": "javascript",
            "label": "javascript",
            "value": 100 - (accumulator % 100),
            "color": "hsl(204, 4%, 42%)"
          }
        ]

  return (
    <div style={{'height': '48vh'}}>
        <ResponsivePie

            data={data}
            margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
            innerRadius={0.5}
            padAngle={0.7}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            borderWidth={1}
            borderColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        0.2
                    ]
                ]
            }}
            arcLinkLabelsSkipAngle={10}
            arcLinkLabelsTextColor="#333333"
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: 'color' }}
            arcLabelsSkipAngle={10}
            arcLabelsTextColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        2
                    ]
                ]
            }}
            defs={[
                {
                    id: 'dots',
                    type: 'patternDots',
                    background: 'inherit',
                    color: 'rgba(255, 255, 255, 0.3)',
                    size: 4,
                    padding: 1,
                    stagger: true
                },
                {
                    id: 'lines',
                    type: 'patternLines',
                    background: 'inherit',
                    color: 	'rgb(220,220,220)',
                    
                    rotation: -45,
                    lineWidth: 6,
                    spacing: 10
                }
            ]}
            
            fill={[
            
                {
                    match: {
                        id: 'erlang'
                    },
                    id: 'dots'
                },
               
                {
                    match: {
                        id: 'javascript'
                    },
                    id: 'lines'
                }
            ]}
            legends={[
                {
                    anchor: 'bottom',
                    direction: 'row',
                    justify: false,
                    translateX: 0,
                    translateY: 56,
                    itemsSpacing: 0,
                    itemWidth: 100,
                    itemHeight: 18,
                    itemTextColor: '#999',
                    itemDirection: 'left-to-right',
                    itemOpacity: 1,
                    symbolSize: 18,
                    symbolShape: 'circle',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemTextColor: '#000'
                            }
                        }
                    ]
                }
            ]}
        />

    </div>
  )
}

export default PieChart